export enum TipoFormatoDadosRelatorio {
    ABSOLUTO = "ABSOLUTO",
    PERCENTUAL = "PERCENTUAL",
    EVOLUCAO = "EVOLUCAO",
    MEDIA = "MEDIA"
}
